import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../api";
import { useAuth } from "../AuthContext";
import { useI18n } from "../I18nContext";

export default function OnboardingBanner() {
  const { t } = useI18n();
  const { user } = useAuth();
  const [state, setState] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!user || user.role !== "entrepreneur") { setLoaded(true); return; }
    api.get("/onboarding/state")
      .then((r) => setState(r.data))
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, [user]);

  if (!loaded || !user || user.role !== "entrepreneur") return null;
  if (!state || !state.eligible) return null;
  const sess = state.session;
  if (sess && sess.status === "complete") return null;

  const brainScore = state.progress?.brain_score ?? sess?.brain_score ?? 0;
  const inProgress = sess && sess.status === "in_progress";
  const dismissed = sess && sess.status === "dismissed";

  return (
    <div className="tb-onb-banner" data-testid="onboarding-banner">
      <div className="tb-onb-banner-body">
        <span className="tb-onb-banner-icon" aria-hidden>🧠</span>
        <div className="tb-onb-banner-text">
          <strong>
            {inProgress
              ? t("onboarding.banner.progressTitle", { pct: brainScore })
              : dismissed
                ? t("onboarding.banner.resumeTitle")
                : t("onboarding.banner.startTitle")}
          </strong>
          <span className="tb-muted">
            {inProgress
              ? t("onboarding.banner.progressSub")
              : t("onboarding.banner.startSub")}
          </span>
        </div>
      </div>
      <Link to="/app/onboarding" className="tb-primary-btn tb-mini" data-testid="onboarding-banner-cta">
        {inProgress ? t("onboarding.banner.continue") : t("onboarding.banner.start")}
      </Link>
    </div>
  );
}
